import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import Icon from 'discada/dist/Icon'

import PricingCard from 'components/VRP/PricingCard'
import Header from 'components/VRP/Header'
import { DirtyButton } from 'components/widgets/Dirty'

export function PricingCardFloater(props) {
  let { className, mode, vehicleId, dirty } = props

  return (
    <div className={c('pricing-card-floater', className, { dirty })}>
      <Header id={vehicleId} />

      <div className="pricing-cards-wrapper">
        {dirty ? (
          <DirtyButton {...props} size="small" />
        ) : (
          <>
            <PricingCard
              {...props}
              mode="lease"
              selected={mode === 'lease'}
              autoHide
              mini
              toggle
            />
            <PricingCard
              {...props}
              mode="loan"
              selected={mode === 'loan'}
              autoHide
              mini
              toggle
            />
            <PricingCard
              {...props}
              mode="cash"
              selected={mode === 'cash'}
              autoHide
              mini
              short
              toggle
            />
          </>
        )}
        <small className="mobile-callout">
          <Icon icon="hand-pointer" />
          Select your Payment!
        </small>
      </div>
    </div>
  )
}

function mapStateToProps(_, op) {
  return { ...op }
}

export default connect(mapStateToProps)(PricingCardFloater)
